import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLayers20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconLayers20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m15.315 6.622-5.07-2.56a.5.5 0 0 0-.45 0l-5.07 2.56 5.07 2.56a.5.5 0 0 0 .45 0zm-4.393-3.9a2 2 0 0 0-1.804 0L2.812 5.909a.8.8 0 0 0 0 1.428l6.306 3.185a2 2 0 0 0 1.804 0l6.306-3.185a.8.8 0 0 0 0-1.428zM2.034 9.635A.75.75 0 0 1 3.04 9.3l6.98 3.49 6.981-3.49a.75.75 0 0 1 .67 1.341l-7.315 3.658-.336.168-.335-.168-7.316-3.658a.75.75 0 0 1-.335-1.006M3.04 12.58a.75.75 0 1 0-.67 1.342l7.315 3.658.335.168.336-.168 7.316-3.658A.75.75 0 0 0 17 12.579l-6.98 3.49z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLayers20);
